import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1856d68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "investigate"
}
const _hoisted_2 = {
  key: 0,
  class: "investigate-context"
}
const _hoisted_3 = { class: "title g-flex-al-center g-flex-jc-between" }
const _hoisted_4 = { class: "g-f18 g-fw7" }
const _hoisted_5 = {
  key: 0,
  class: "questions"
}
const _hoisted_6 = { class: "sub-title g-fw7 g-f14" }
const _hoisted_7 = {
  key: 0,
  class: "answer"
}
const _hoisted_8 = {
  key: 1,
  class: "answer g-mt10"
}
const _hoisted_9 = { class: "btn g-flex-jc-center" }
const _hoisted_10 = {
  key: 0,
  class: "saveSuccess"
}
const _hoisted_11 = { class: "g-f18 g-fw7 g-mt20 g-mb10" }
const _hoisted_12 = { class: "g-f14" }

import { ElIcon } from "element-plus";
import {
  DocumentChecked,
  CloseBold,
  SuccessFilled,
} from "@element-plus/icons-vue";
import { onMounted, ref } from "vue";
import {
  getSurveyTemplate,
  getSurveyAdd,
  getSurveyStatus,
  getSurveyClose,
} from "@/api/request/survey";
import { upgradeAccount } from "@/utils";
import ScrollArea from "@/components/scrollArea.vue";

interface templateType {
  type: "num" | "str";
  title: string;
  value: number;
}
/** 问题列表 */

export default /*#__PURE__*/_defineComponent({
  __name: 'Investigate',
  props: {
  showVisitorSurvey: {
    type: Function,
    required: false,
  },
},
  setup(__props) {

const $props = __props;



async function openDialog() {
  // if (upgradeAccount()) return;
  let { status } = await upgradeAccount();
  if (status === "confirm") {
    $props.showVisitorSurvey && $props.showVisitorSurvey("confirm");
    return; 
  }
  if(status === 'cancel' || status === 'close'){ 
    return
  }
  isShow.value = true;
}
/** 是否弹起调查问卷弹窗 */
const isShow = ref(false);
/** 是否展示调查问卷系统 */
const isHidden = ref(true);
/** 正在提交 */
const loading = ref(false);
const time = ref(3);
/** 倒计时 */
let timer: null | number = null;
/** 是否成功反馈 */
const isSuccess = ref(false);
/** 保存调查问卷 */
function save() {
  isSuccess.value = true;
  loading.value = true;
  getSurveyAdd({
    surveyJson: questionList.value,
    surveyVersion: qusetionVersion.value,
  })
    .then(() => {
      isSuccess.value = true;
      timer = setInterval(() => {
        time.value--;
        if (time.value <= 0) {
          clearInterval(timer as number);
          close();
        }
      }, 1000);
    })
    .finally(() => {
      loading.value = false;
    });
}
/** 关闭调查问卷 */
function close() {
  getSurveyClose();
  isShow.value = false;
  if (isSuccess.value) {
    isHidden.value = false;
  }
}
const questionList = ref([] as templateType[]);
const qusetionVersion = ref("");
onMounted(() => {
  // 判断当前用户反馈状态
  getSurveyStatus().then((res) => {
    // if (res.data === "tip") {
    //   isShow.value = true;
    //   getTemplate();
    // }
    // if (res.data === "normal") {
    //   isShow.value = false;
    //   getTemplate();
    // }
    if (res.data === "hidden") {
      isHidden.value = false;
    } else {
      isShow.value = false;
      getTemplate();
    }
  });
});
/** 请求调查模板 */
function getTemplate() {
  getSurveyTemplate().then((res) => {
    questionList.value = JSON.parse(res.data.surveyJson);
    qusetionVersion.value = res.data.surveyVersion;
  });
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (isHidden.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_tooltip, {
          class: "box-item",
          effect: "dark",
          content: _ctx.$t('调查问卷'),
          placement: "left"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "icon g-flex-jc-center g-flex-al-center g-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openDialog()))
            }, [
              _createVNode(_unref(ElIcon), { size: "25" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DocumentChecked))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["content"]),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (isShow.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("出海学堂满意度调查")), 1),
                    _createElementVNode("div", {
                      class: "clear g-pointer",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
                    }, [
                      _createVNode(_unref(ElIcon), { size: "24" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(CloseBold))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (!isSuccess.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (isShow.value)
                          ? (_openBlock(), _createBlock(ScrollArea, { key: 0 }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionList.value, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item.title,
                                    class: "item p-r-10 g-mb10"
                                  }, [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
                                    (item.type === 'num')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                          _createVNode(_component_el_rate, {
                                            modelValue: item.value,
                                            "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                            size: "large",
                                            "allow-half": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                          _createVNode(_component_el_input, {
                                            modelValue: item.value,
                                            "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                            rows: 4,
                                            type: "textarea",
                                            placeholder: _ctx.$t('请简述您的问题')
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                        ]))
                                  ]))
                                }), 128)),
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_el_button, {
                                    type: "danger",
                                    size: "large",
                                    round: "",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (save()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("  " + _toDisplayString(_ctx.$t("提交")) + "  ", 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                      (isSuccess.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(_unref(ElIcon), {
                              color: "#67c23a",
                              size: "60"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SuccessFilled))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("感谢您的反馈")), 1),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("N秒后自动关闭", { text: time.value })), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])), [
                  [_directive_loading, loading.value]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})